<!-- Shortcuts toggle -->
<button mat-icon-button (click)="openPanel()" #shortcutsOrigin>
	<i class="material-icons mat-icon -mt-1 icon-size-6">&#xe889;</i>
</button>
<!-- Shortcuts panel -->
<ng-template #shortcutsPanel>
	<div
		class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg"
	>
		<!-- Header -->
		<div
			class="flex shrink-0 items-center py-1 pr-4 pl-6 bg-primary text-on-primary"
		>
			<div class="sm:hidden -ml-1 mr-3">
				<button mat-icon-button (click)="closePanel()">
					<mat-icon
						class="icon-size-5 text-current"
						[svgIcon]="'heroicons_solid:x-mark'"
					></mat-icon>
				</button>
			</div>
			<div class="flex items-center text-lg font-medium leading-10">
				<span class="">Recently Viewed</span>
			</div>
		</div>
		<!-- Content -->
		<div
			class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card"
		>
			<!-- Shortcuts -->
			@for (shortcut of shortcuts; track trackByFn($index, shortcut)) {
			<div
				class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
			>
				<!-- Message with a link -->
				<ng-container>
					<!-- Router links -->
					<ng-container>
						<a
							class="flex flex-auto py-5 pl-6 cursor-pointer"
							[routerLink]="shortcut.url"
							(click)="closePanel()"
						>
							<ng-container
								*ngTemplateOutlet="messageContent"
							></ng-container>
						</a>
					</ng-container>
				</ng-container>
			</div>
			<!-- Message content template -->
			<ng-template #messageContent>
				<!-- Title, description & time -->
				<div class="flex flex-col flex-auto">
					@if (shortcut.recordName) {
					<div
						class="font-semibold line-clamp-1"
						[innerHTML]="shortcut.recordName"
					></div>
					} @if (shortcut.recordType) {
					<div
						class="line-clamp-2"
						[innerHTML]="shortcut.recordType | camelCaseString"
					></div>
					}
				</div>
			</ng-template>
			}
			<!-- No shortcuts -->
			@if (!shortcuts || !shortcuts.length) {
			<div
				class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8"
			>
				<div
					class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600"
				>
					<mat-icon
						class="text-primary-700 dark:text-primary-50"
						[svgIcon]="'heroicons_outline:bookmark'"
					></mat-icon>
				</div>
				<div class="mt-5 text-2xl font-semibold tracking-tight">
					No recently viewed
				</div>
				<div
					class="w-full max-w-60 mt-1 text-md text-center text-secondary"
				>
					When you have recently viewed, they will appear here.
				</div>
			</div>
			}
		</div>
	</div>
</ng-template>
